/** `feature_list`에서 `${targetFeatureKey}_${groupType}` 패턴을 찾아 groupType을 반환한다. (미매칭: `null`, 정규화 없음) */
export const getGroupTypeFromFeatureList = <TGroupType extends string>(
  featureList: readonly string[] | null | undefined,
  targetFeatureKey: string,
  groupTypes: readonly TGroupType[],
): TGroupType | null => {
  if (!featureList || featureList.length === 0) {
    return null;
  }

  let matchedGroupType: TGroupType | null = null;

  for (const feature of featureList) {
    // feature는 'abt_key_A' 형태로, 마지막 '_' 이후가 그룹 타입
    const lastUnderscoreIndex = feature.lastIndexOf('_');
    if (lastUnderscoreIndex === -1) {
      continue;
    }

    // 마지막 '_'를 기준으로 key와 groupType 분리
    // 예: '202509_onboarding_coupon_ABT_R_B' → key: '202509_onboarding_coupon_ABT_R', groupType: 'B'
    const key = feature.substring(0, lastUnderscoreIndex);
    const groupType = feature.substring(lastUnderscoreIndex + 1);

    if (key !== targetFeatureKey) {
      continue;
    }

    if (!groupTypes.includes(groupType as TGroupType)) {
      continue;
    }

    // featureList 순서 기준으로 마지막 매칭이 우선
    matchedGroupType = groupType as TGroupType;
  }

  return matchedGroupType;
};

